var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 20,
    height: 20,
    rx: 4,
    fill: "#1167ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.55094 9.97641C3.84022 9.68714 4.30923 9.68714 4.59851 9.97641L8.54913 13.927C8.8384 14.2163 8.8384 14.6853 8.54913 14.9746C8.25985 15.2639 7.79084 15.2639 7.50156 14.9746L3.55094 11.024C3.26167 10.7347 3.26167 10.2657 3.55094 9.97641Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4504 6.0258C16.7396 6.31507 16.7396 6.78408 16.4504 7.07336L8.54913 14.9746C8.25985 15.2639 7.79084 15.2639 7.50156 14.9746C7.21228 14.6853 7.21228 14.2163 7.50156 13.927L15.4028 6.0258C15.6921 5.73652 16.1611 5.73652 16.4504 6.0258Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxChecked);
export default __webpack_public_path__ + "static/media/checkbox_checked.a0f974e2c39c0a99e58554c52abf3ab3.svg";
export { ForwardRef as ReactComponent };